module.exports = __webpack_public_path__ + "static/media/companion-img-002.870c6a47.jpg";